// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"328":"99d7d636","415":"7db679f2","493":"4595b682"}[chunkId] + ".chunk.js";
};